module.exports = __webpack_public_path__ + "img/306.342f044a.jpg";